import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

interface SimpleProjectCardProps {
  project: {
    id: string;
    projectName: string;
    location: string;
    quantity: number;
    currentValue: number;
  };
}

export const SimpleProjectCard = ({ project }: SimpleProjectCardProps) => {
  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="font-semibold text-lg mb-2">{project.projectName}</h3>
        <p className="text-sm text-muted-foreground mb-4">{project.location}</p>
        <div className="flex justify-between items-center">
          <span>{project.quantity} credits</span>
          <Badge>${project.currentValue}</Badge>
        </div>
        <Button className="w-full mt-4" size="sm">
          View Details
        </Button>
      </CardContent>
    </Card>
  );
};